import { analyticsRepository } from "@/repositories/analytics";
import { useStore } from "@/stores/useStore";
import { useCallback } from "react";

const CARD_SIZE_CHANGED_EVENT = "card_size_changed";

export const useCardSizeAnalytics = () => {
  const shopId = useStore((s) => s.shopId);

  const logCardSizeChanged = useCallback(
    (zoomLevel: number, direction: "in" | "out") => {
      if (!shopId) {
        console.error(
          "Shop ID is missing, cannot log analytics event:",
          CARD_SIZE_CHANGED_EVENT
        );
        return;
      }
      analyticsRepository.logAnalyticsEvent(CARD_SIZE_CHANGED_EVENT, {
        shopId,
        zoomLevel,
        direction,
      });
    },
    [shopId]
  );

  return { logCardSizeChanged };
};
